import { useEffect, useState } from "react";
import { api, formatEUR } from "../lib/api";
import Layout, { Card, Label, Badge, Spinner } from "../components/Layout";
import { Plus, Trash, Buildings } from "@phosphor-icons/react";

export default function Partners() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/partners");
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Eliminare il partner?")) return;
    await api.delete(`/partners/${id}`);
    load();
  };

  return (
    <Layout
      title="Partner & ATI"
      subtitle="Anagrafica operatori per raggruppamenti temporanei d'impresa"
      actions={<button onClick={() => setShow(true)} className="btn-primary" data-testid="btn-new-partner"><Plus size={14} className="inline mr-1.5" /> Nuovo Partner</button>}
    >
      {loading ? <Spinner /> :
       items.length === 0 ? (
         <Card><div className="text-sm text-zinc-500 py-8 text-center">Nessun partner. Aggiungi il primo operatore.</div></Card>
       ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="partners-grid">
          {items.map((p) => (
            <Card key={p.id} data-testid={`partner-${p.id}`}>
              <div className="flex justify-between items-start mb-2">
                <Buildings weight="duotone" size={24} className="text-klein" />
                <button onClick={() => del(p.id)} className="text-zinc-400 hover:text-red-600" data-testid={`del-${p.id}`}><Trash size={16} /></button>
              </div>
              <h3 className="font-display font-bold text-lg tracking-tight">{p.name}</h3>
              <div className="font-mono text-xs text-zinc-500">{p.vat} • {p.legal_form}</div>
              <div className="mt-3 space-y-1 text-xs">
                <div><span className="text-zinc-500">Settori:</span> {p.sectors.join(", ") || "—"}</div>
                <div><span className="text-zinc-500">Fatturato:</span> {formatEUR(p.revenue)}</div>
                {p.contact_email && <div><span className="text-zinc-500">Email:</span> {p.contact_email}</div>}
              </div>
              {p.certifications.length > 0 && (
                <div className="mt-3 flex gap-1 flex-wrap">
                  {p.certifications.map((c, i) => <Badge key={i}>{c}</Badge>)}
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      {show && <NewPartner onClose={() => setShow(false)} onCreated={() => { setShow(false); load(); }} />}
    </Layout>
  );
}

function NewPartner({ onClose, onCreated }) {
  const [f, setF] = useState({ name: "", vat: "", legal_form: "S.r.l.", address: "", sectors: "", certifications: "", revenue: 0, contact_email: "", contact_phone: "", notes: "" });
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/partners", {
      ...f,
      revenue: parseFloat(f.revenue) || 0,
      sectors: f.sectors.split(",").map(s => s.trim()).filter(Boolean),
      certifications: f.certifications.split(",").map(s => s.trim()).filter(Boolean),
    });
    onCreated();
  };

  return (
    <div className="fixed inset-0 bg-zinc-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="modal-new-partner">
      <form onSubmit={submit} className="bg-white border border-zinc-300 w-full max-w-xl p-6 space-y-3 max-h-[90vh] overflow-y-auto">
        <h2 className="font-display text-2xl font-extrabold tracking-tighter">Nuovo Partner</h2>
        <Field label="Ragione Sociale *"><input className="input-field" required value={f.name} onChange={upd("name")} data-testid="p-name" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="P.IVA *"><input className="input-field" required value={f.vat} onChange={upd("vat")} data-testid="p-vat" /></Field>
          <Field label="Forma Giuridica"><input className="input-field" value={f.legal_form} onChange={upd("legal_form")} /></Field>
        </div>
        <Field label="Indirizzo"><input className="input-field" value={f.address} onChange={upd("address")} /></Field>
        <Field label="Settori (separati da virgola)"><input className="input-field" value={f.sectors} onChange={upd("sectors")} placeholder="ICT, Cybersecurity" data-testid="p-sectors" /></Field>
        <Field label="Certificazioni (separati da virgola)"><input className="input-field" value={f.certifications} onChange={upd("certifications")} placeholder="ISO 9001, ISO 27001, SOA OG1" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Fatturato EUR"><input type="number" className="input-field" value={f.revenue} onChange={upd("revenue")} /></Field>
          <Field label="Email"><input type="email" className="input-field" value={f.contact_email} onChange={upd("contact_email")} /></Field>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">Annulla</button>
          <button type="submit" className="btn-primary" data-testid="p-save">Salva</button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return <div><div className="label-up mb-1">{label}</div>{children}</div>;
}
